module.exports = __webpack_public_path__ + "static/media/33447d8d-d920-48e7-b0a9-1d3dda80d6a6.391499c4.ttf";